function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0C3.35785 0 0 3.35785 0 7.5C0 11.6421 3.35785 15 7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35785 11.6421 0 7.5 0ZM7.5 1.45161C10.8427 1.45161 13.5484 4.15678 13.5484 7.5C13.5484 10.8427 10.8432 13.5484 7.5 13.5484C4.1573 13.5484 1.45161 10.8432 1.45161 7.5C1.45161 4.1573 4.15678 1.45161 7.5 1.45161ZM11.74 5.39114L11.0585 4.7041C10.9174 4.56181 10.6876 4.56088 10.5453 4.70205L6.27054 8.94245L4.46232 7.11956C4.32118 6.97727 4.0914 6.97633 3.94911 7.11747L3.26205 7.799C3.11976 7.94014 3.11882 8.16992 3.25999 8.31224L6.00538 11.0799C6.14652 11.2221 6.3763 11.2231 6.51859 11.0819L11.738 5.90438C11.8803 5.76321 11.8812 5.53343 11.74 5.39114Z",
  fill: "black"
});

var SvgApproveCircle = function SvgApproveCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApproveCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approve-circle.b4511a5d.svg";
export { ForwardRef as ReactComponent };